module.exports = __webpack_public_path__ + "img/users.9be6776e.svg";